// src/utils/accessUtils.js

/**
 * Safely parse a JSON array (e.g., emp_roles or emp_groups),
 * handling both JSON string or array input.
 */
export function parseJsonArray(input) {
  try {
    const parsed = typeof input === "string" ? JSON.parse(input) : input;
    return Array.isArray(parsed) ? parsed.map(Number) : [];
  } catch {
    return [];
  }
}

/**
 * ⚠️ App-admin flag:
 * Keep this EXACT behavior: userRole === 1 => adminOnly
 * (This is NOT the same as emp_roles-driven permissions.)
 */
export function isAdmin(userRole) {
  return Number(userRole) === 1;
}
